export default __webpack_public_path__ + "static/media/NSECORP.ff33f264.png";